/**
 * 去除首尾花括号
 * @param {String} str 目标字符串
 */
function removeBlock(str) {
    const reg = /^\{/gi
    const reg2 = /\}$/gi
    if (!str)
        return str
    str = str.replace(reg, '')
    str = str.replace(reg2, '')
    return str

}

/**
 * Tree
 * @param {Array} data tree list
 * @param {String} key tree节点的唯一标识
 * @param {String} parentKey tree节点的父节点标识
 * @param {*} rootKey 根节点值
 * @param {*} map
 */
function TreeUtil(data = [], key = 'id', parentKey= 'parentId', rootKey = 0, map = {}) {
    this.data = data
    this.key = key
    this.parentKey = parentKey
    this.children = 'children'
    this.treeKey = this.key
    this.map = map
    this.rootKey = rootKey
    if (map)
        if (map[this.key])
            this.treeKey = map[this.key]
    /**
    * 数组转tree
    */
    this.composeTree = function () {
        let list = this.data
        const data = JSON.parse(JSON.stringify(list)) // 浅拷贝不改变源数据
        const result = []
        if (!Array.isArray(data)) {
            return result
        }
        data.forEach(item => {
            delete item[this.children]
        })
        data.forEach(item => {
            this.map[item[this.key]] = item
        })
        data.forEach(item => {
            if (item[this.parentKey] !== undefined) {
                const parent = this.map[item[this.parentKey]]
                if (parent)
                    (parent[this.children] || (parent[this.children] = [])).push(item)
                else
                    result.push(item)
            }
        })
        return result
    }
    /**
     * 获取整颗tree的1个分支
     * @param {*} keyVal
     * @param {*} tree
     * @returns
     */
    this.toBranch = function (keyVal, tree = undefined) {
        tree = tree || this.composeTree()
        let o = {}
        o[this.key] = keyVal || this.rootKey
        let findStr = JSON.stringify(o)
        findStr = removeBlock(findStr)
        for (let i = 0; i < tree.length; i++) {
            const item = tree[i]
            let itemStr = JSON.stringify(item)
            if (itemStr.indexOf(findStr) > -1)
                return [item]
        }
        return tree
    }
    /**
     * 获取指定节点的子节点tree
     * @param {*} keyVal
     * @param {*} tree
     * @returns
     */
    this.toChildren = function (keyVal, tree = undefined) {
        keyVal = keyVal || this.rootKey
        tree = tree || this.toBranch(keyVal)
        if (tree.length > 1)
            tree = this.toBranch(keyVal, tree)
        for (let i = 0; i < tree.length; i++) {
            const item = tree[i]
            if (item[this.key] === keyVal)
                return [item]
            if (item[this.children])
                return this.toChildren(keyVal, item[this.children])
        }
        return []
    }
    this.toTree = function () {
        if (this.rootKey < 0)
            return this.composeTree()
        let data = this.data;
        let pos = {};
        let tree = [];
        let i = 0;
        var maxcount = 0;
        while (data.length > 0) {
            if (data[i][this.parentKey] === this.rootKey) {
                let _temp = this.copy(data[i]);
                tree.push(_temp);
                pos[data[i][this.key]] = [tree.length - 1];
                data.splice(i, 1);
                i--;
            } else {
                let posArr = pos[data[i][this.parentKey]];
                if (posArr !== undefined) {
                    let obj = tree[posArr[0]];
                    for (let j = 1; j < posArr.length; j++) {
                        obj = obj.children[posArr[j]];
                    }
                    let _temp = this.copy(data[i]);
                    obj.children.push(_temp);
                    pos[data[i][this.key]] = posArr.concat([obj.children.length - 1]);
                    data.splice(i, 1);
                    i--;
                }
                else {
                    maxcount++;
                    if (maxcount >= 100)//没有找到父节点的最大次数
                    {
                        window.console.warn("not find parent");
                        break;
                    }
                }
            }
            i++;
            if (i > data.length - 1) {
                i = 0;
            }

        }
        return tree;
    }
    this.copy = function (item) {
        let _temp = {
            children: []
        };
        _temp[this.treeKey] = item[this.key];
        for (let _index in item) {
            if (_index !== this.key && _index !== this.parentKey) {
                let _property = item[_index];
                if ((!!this.map) && this.map[_index])
                    _temp[this.map[_index]] = _property;
                else
                    _temp[_index] = _property;
            }
        }
        return _temp;
    }
}

// arr 数据数组
// data 选中的值
export function resverTree(arr, data, key = 'id') {
    var array = []
    for (var i = 0; i < data.length; i++) {
        fun(data[i], arr, array, key)
    }
    return array;
}

function fun(value, data, arr, key) {
    for (var i = 0; i < data.length; i++) {
        var mod = data[i]
        if (mod[key] === value) {
            if (!mod.children || mod.children.length < 1) {
                arr.push(mod[key])
                return true
            }
            return true
        } else {
            if (mod.children && mod.children.length < 1) {
                fun(value, mod.children, arr, key)
            }
        }
    }
    return true
}

export default TreeUtil
